<script context="module" lang="ts">
  let nextId = 0;
</script>

<script lang="ts">
  /** 0..1 training status rating (5 stars == 1), with partial fill on the last star. */
  export let rating: number;
  export let color = '#374151'; // Neutral: status is shown by star count only, not colour
  export let size = 12;

  const id = `season-star-${nextId++}`;
  const stars = [0, 1, 2, 3, 4];
  $: filled = Math.max(0, Math.min(5, rating * 5));
  $: fill = (n: number) => Math.max(0, Math.min(1, filled - n)) * 100;
</script>

<span class="inline-flex items-center whitespace-nowrap" title="{filled.toFixed(1)} stars">
  {#each stars as n}
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" width={size} height={size * 0.89}>
      <defs>
        <linearGradient id="{id}-{n}" x1="0%" x2="100%" y1="0%" y2="0%">
          <stop offset="{fill(n)}%" stop-color={color} />
          <stop offset="{fill(n)}%" stop-color="#d6d6d6" />
        </linearGradient>
      </defs>
      <path
        fill="url(#{id}-{n})"
        d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"
      />
    </svg>
  {/each}
</span>
